import {Button} from "@mui/material";
import {styled} from "@mui/material/styles";

export const StyledButton = styled(Button)({
    gap: "10px",
    borderRadius: "4px",
});
